import React, { Component } from 'react'
import { View, StyleSheet, Platform } from 'react-native'

import ActionWrapper from './ActionWrapper'

export default class Group extends Component {
  render() {
    const { object, children, component, styleOverrides, nodeHeight } =
      this.props
    const { groupType, layout } = object

    // All type.group with !groupType were removed before,
    // so this is responsiveLayout only behavior
    if (!groupType) {
      const minHeightStyle = {}
      if (nodeHeight && Platform.OS === 'android') {
        // The wrapping View must completely wrap it's child for all the content within it to be tappable in android.
        // If nodeHeight isn't set as the height, it'll only have the object.layout height set, which could be less than
        // the inner child's height if it has variable height content, and not all the content within it would be tappable.
        minHeightStyle.minHeight = nodeHeight
      }
      return (
        <ActionWrapper
          component={component}
          object={object}
          style={[layout, styleOverrides, minHeightStyle]}
        >
          <View
            style={[styles.responsiveGroup, minHeightStyle]}
            pointerEvents="box-none"
          >
            {children}
          </View>
        </ActionWrapper>
      )
    }

    return (
      <ActionWrapper
        component={component}
        object={object}
        style={[styles.group, styleOverrides]}
      >
        <View style={styles.oldGroup} pointerEvents="box-none">
          {children}
        </View>
      </ActionWrapper>
    )
  }
}

const styles = StyleSheet.create({
  oldGroup: {
    flex: 1,
  },
  responsiveGroup: {
    position: 'relative',
    height: '100%',
  },
})
